<template>
  <div class="layout">
    <!-- 검색 영역 -->
    <div class="sp-search">
      <h2>특수분류</h2>
      <div class="search-wrap align-end">
				<div class="search-box">
					<label for="orderByType" class="ir">검색순서</label>
					<select id="orderByType" v-model="orderByType">
						<option value="D">최신순</option>
						<option value="A">과거순</option>
					</select>
					<label for="searchType" class="ir">검색카테고리</label>
					<select id="searchType">
						<option value="">제목 / 내용</option>
					</select>
					<label for="searchText" class="ir">검색창</label>
					<input type="search" v-model="searchText" v-on:keyup.enter="searchBoardTotalList(1, 10, 1)" id="searchText" />
					<button type="submit" @click="searchBoardTotalList(1, 10, 1)">검색</button>
		  		</div>
			</div>
    </div>
    <!-- // 검색 영역 -->
    <SpclClsfListItem :board-list-data="listData"/>
    <BoardPagination :pageSetting="pageDataSetting(this.page)" @paging="pagingMethod" />
  </div>
</template>
    
<script>
import * as api from '@/api/Notice.js'
import SpclClsfListItem from '@/components/SpclClsfListItem'
import BoardPagination from '@/components/BoardPagination'

export default {
  name: 'SpclClsf',

	components: {
		SpclClsfListItem,
		BoardPagination
	},

	data () {
		return {
			boardType: '000349',
			searchText: '',
			orderByType: 'D',
			listData: [],
			total: 0,
			page: 1,
			limit: 5,
			block: 10,
			startIdx: 1,
			endIdx: 10
		}
	},

	created () {
		this.initBoard()
	},

	mounted () {
		if (window.innerWidth <= 768) {
			this.block = 5
		}
	},

	methods: {
		initBoard () {
			if (this.$route.query.page) {
				this.page = this.$route.query.page
			}

			if (this.$route.query.searchText) {
				this.searchText = this.$route.query.searchText
			}

			if (this.$route.query.orderByType) {
				this.orderByType = this.$route.query.orderByType
			}

			this.searchBoardTotalList(this.page)
		},

		// 게시판 전체 목록
		async searchBoardTotalList (currentPage) {
			this.startIdx = ((currentPage - 1) * this.limit) + 1
			this.endIdx = currentPage * this.limit
			this.page = currentPage

			const paramData = {
				boardType: this.boardType,
				searchText: this.searchText,
				orderByType: this.orderByType,
				startPage: this.startIdx,
				endPage: this.endIdx
			}

			const boardData = await api.searchBoardList(paramData)
			this.listData = boardData.data

			const totalCnt = await api.boardCnt(paramData)
			this.total = totalCnt.cnt
			this.pageDataSetting(currentPage)
		},

		pagingMethod (page) {
			this.$router.replace({
				name: '특수분류',
				query: {
					page: page,
					searchText: this.searchText,
					orderByType: this.orderByType
				}
			}).catch(() => {})
		},

		pageDataSetting (currentPage) {
			const totalPage = Math.ceil(this.total / this.limit)
			const first = currentPage > 1 ? parseInt(currentPage, 10) - parseInt(1, 10) : null
			const end = totalPage !== currentPage ? parseInt(currentPage, 10) + parseInt(1, 10) : null

			const startIndex = (Math.ceil(currentPage / this.block) - 1) * this.block + 1
			const endIndex = startIndex + this.block > totalPage ? totalPage : startIndex + this.block - 1
			const list = []
			for (let index = startIndex; index <= endIndex; index++) {
				list.push(index)
			}
			return { first, end, list, currentPage, totalPage }
		}
	},

	watch: {
		$route (to, from) {
			if (to.path == from.path) {
				this.initBoard()
			}
		}
	}
}
</script>

<style scoped>

</style>
  